import WidgetFilter from './WidgetFilter';

export default WidgetFilter;
